import Dialog from "@/components/ui/Dialog/Dialog";
import { Button } from "@/components/ui/Button";
import { useTranslation } from "react-i18next";

export default function FirstTimeDialog(p: {
  show: boolean;
  close: () => void;
}) {
  const {t} = useTranslation();
  return (
    <Dialog isOpen={p.show} onClose={p.close} onRequestClose={p.close}>
      <h5 className="mb-4">{t("home.whatIsThis.title")}</h5>
      <div className="space-y-4">
        <p>{t("home.whatIsThis.paragraph1")}</p>

        <p>
          {t('home.whatIsThis.paragraph2')}
        </p>

        <p className={"justify-center flex"}>
          <Button variant={"solid"} onClick={() => p.close()}>
            {t('home.whatIsThis.continue')}
          </Button>
        </p>
      </div>
    </Dialog>
  );
}
